define('viewmodels/modals/dialogs/ChangeMobileNumberDialog',['knockout', 'underscore'], function (ko, _) {

    var ChangeMobileNumberDialog = function (
        dialog,
        formFields,
        settingsModel,
        Wizard,
        wpMobileNumber,
        navigation
    ) {
        var self = this,
            shouldSendVerificationCodeRequest = false;

        self.dialog = dialog;
        self.topBarAction = ko.observable();
        self.topBar = ko.observable();
        self.disposableSubscriptions = [];

        self.translations = {
            headers: {
                first: wpMobileNumber('first_step_header'),
                second: wpMobileNumber('second_step_header')
            },
            tip: wpMobileNumber('enter_code_tip')
        };

        self.wizardModel = new Wizard({
            steps: [
                {
                    field: formFields.phoneNumberField(settingsModel.phoneNumber),
                    label: ko.observable(''),
                    type: 'basicfield',
                    placeholder: ko.observable(''),
                    dialogTitle: self.translations.headers.first
                },
                {
                    field: formFields.textField(settingsModel.verificationCode),
                    label: self.translations.tip.replacements({
                        phoneNumber: ko.pureComputed(function () {
                            return '(' + settingsModel.phoneNumber.prefix() + ') '
                                + settingsModel.phoneNumber.number();
                        })
                    }),
                    type: 'numericKeypad',
                    placeholder: ko.observable('    '),
                    dialogTitle: self.translations.headers.second
                }
            ],
            onComplete: function () {
                return settingsModel.verifyPhoneNumberCommand.dispatch(function () {
                    self.close();
                    navigation.navigate(navigation.ROUTES.SETTINGS);
                });
            },
            stepsHook: this.topBar,
            backHook: this.topBarAction
        });

        self.disposableSubscriptions.push(
            settingsModel.phoneNumber.number.subscribe(function () {
                shouldSendVerificationCodeRequest = true;
            })
        );

        self.disposableSubscriptions.push(
            settingsModel.phoneNumber.prefix.subscribe(function () {
                shouldSendVerificationCodeRequest = true;
            })
        );

        self.title = self.wizardModel.step().dialogTitle;

        //when moving to step 2 - send verification code request
        this.wizardModel.stepNumber.subscribe(function (param) {
            var command;

            if (param === 2 && shouldSendVerificationCodeRequest) {
                shouldSendVerificationCodeRequest = false;
                command = settingsModel.createVerificationCodeRequestCommand({
                    phoneNumber: {
                        prefix: settingsModel.phoneNumber.prefix,
                        number: settingsModel.phoneNumber.number
                    }
                });

                command.dispatch();
            }
        });
    };

    ChangeMobileNumberDialog.prototype.close = function () {
        this.dialog.close(this);

        _.each(this.disposableSubscriptions, function (subscription) {
            subscription.dispose();
        }.bind(this));
    };

    return ChangeMobileNumberDialog;
});

